import { endpoints } from '../endpoints'
import { http } from '../http'
import { FuneralHome } from '../../types'

export const funeralHomes = {
  load: (): Promise<FuneralHome> => http.get(endpoints.funeralHome),
}
